import TableEvents from "./TableEvents";
export default TableEvents;
export { default as TableEvents } from './TableEvents';